"use strict";
/*
  based on: https://github.com/rzeigler/waveguide/blob/master/src/ticket.ts
  credits to original author
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var T = __importStar(require("./effect"));
function ticketExit(ticket, exit) {
    if (exit._tag === "Interrupt") {
        return ticket.cleanup;
    }
    return T.unit;
}
exports.ticketExit = ticketExit;
function ticketUse(ticket) {
    return ticket.acquire;
}
exports.ticketUse = ticketUse;
function makeTicket(acquire, cleanup) {
    return {
        acquire: acquire,
        cleanup: cleanup
    };
}
exports.makeTicket = makeTicket;
